import EventEmitter from 'eventemitter3'
import * as PIXI from 'pixi.js'
import gsap from 'gsap'
import MyApplication from '../../../pixi/MyApplication'
import AssetsManager from '../../../pixi/AssetsManager'
import BtnView from './BtnView'
import CardView from '../game/CardView'
import CardModel from '../data/CardModel'
import { CARD_TYPE } from '../constant/CardType'
import ArrayUtil from '../../../util/ArrayUtil'

/**
 * TopViewクラス
 */
class TopView extends PIXI.Container {
  // ---------------------------------------------------------------------------------------------------------
  // --	VARS
  // ---------------------------------------------------------------------------------------------------------

  //アプリケーション
  private _app: PIXI.Application

  //カード用コンテナ
  private _cardContainer: PIXI.Container

  //コンテナ
  private _container: PIXI.Container

  //タイトル
  private _titleBorder: PIXI.Sprite
  private _title: PIXI.Sprite

  //ボタン
  private _startBtn: BtnView
  private _rankingBtn: BtnView

  //カード生成用のTween
  private _delayedCall: gsap.core.Tween

  //カードモデル
  private _cardModels: Array<CardModel>

  //カードインデックス
  private _cardIndex: number = -1

  //更新ファンクション
  private _update: any

  //イベントエミッター
  private _emitter: EventEmitter = new EventEmitter()
  public get emitter(): EventEmitter {
    return this._emitter
  }

  // ---------------------------------------------------------------------------------------------------------
  // --	TopView
  // ---------------------------------------------------------------------------------------------------------

  /**
   * コンストラクタ
   */
  constructor() {
    super()

    //app参照
    this._app = MyApplication.app

    //カードデータを生成
    this._cardModels = []
    for (let i = 0; i < 52; i++) {
      let type: CARD_TYPE
      if (i < 13) {
        type = CARD_TYPE.HEART
      } else if (i < 26) {
        type = CARD_TYPE.DIAMOND
      } else if (i < 39) {
        type = CARD_TYPE.SPADE
      } else {
        type = CARD_TYPE.CLUB
      }
      const card: CardModel = new CardModel(type, (i % 13) + 1)
      this._cardModels.push(card)
    }

    //カードをシャッフル
    this._cardModels = ArrayUtil.shuffleArray(this._cardModels)

    //重ね順
    this.zIndex = 10

    //カード用コンテナ
    this._cardContainer = new PIXI.Container()
    this._cardContainer.sortableChildren = true
    this.addChild(this._cardContainer)

    //コンテナ
    this._container = new PIXI.Container()
    this.addChild(this._container)

    //タイトルのボーダー配置
    this._titleBorder = AssetsManager.instance.createSpriteByName('title_border.png')
    this._titleBorder.anchor.set(0.5, 0.5)
    this._titleBorder.scale.set(3, 3)
    this._titleBorder.x = 0
    this._titleBorder.y = -200
    this._container.addChild(this._titleBorder)

    //タイトル配置
    this._title = AssetsManager.instance.createSpriteByName('title_text.png')
    this._title.anchor.set(0.5, 0.5)
    this._title.scale.set(3, 3)
    this._title.x = 0
    this._title.y = -200
    this._container.addChild(this._title)

    //スタートボタン
    this._startBtn = new BtnView('START')
    this._startBtn.y = 0
    this._container.addChild(this._startBtn)
    this._startBtn.on('mousedown', (e) => {
      this.start()
    })
    this._startBtn.on('touchstart', (e) => {
      this.start()
    })

    //ランキングボタン
    this._rankingBtn = new BtnView('RANKING')
    this._rankingBtn.y = this._startBtn.y + 80
    // this._container.addChild(this._rankingBtn)
    this._rankingBtn.on('mousedown', (e) => {
      this._emitter.emit('RANKING')
    })
    this._rankingBtn.on('touchstart', (e) => {
      this._emitter.emit('RANKING')
    })

    //リセット
    this.reset()
  }

  /**
   * リセット
   */
  reset() {
    this.visible = false
  }

  // --------------------------------------------------------------------------------------------------------------------------------------
  // --	 開く/閉じる
  // --------------------------------------------------------------------------------------------------------------------------------------

  /**
   * 開く
   */
  open() {
    //ボタンをアクティブにする
    this._startBtn.activate(true)

    //カード生成
    this.createCard()

    //表示
    this.visible = true
  }

  /**
   * スタート
   */
  start(): void {
    //SE
    AssetsManager.instance.playSound('sound_click')

    //ボタンを非アクティブに
    this._startBtn.activate(false)

    //カード生成停止
    this._delayedCall.kill()

    //イベント発行
    this._emitter.emit('START')
  }

  /**
   * 閉じる
   */
  close() {}

  // --------------------------------------------------------------------------------------------------------------------------------------
  // --	 カード
  // --------------------------------------------------------------------------------------------------------------------------------------

  /**
   * カードを生成する
   */
  createCard(): void {
    //カード
    this._cardIndex++
    const cardModel: CardModel = this._cardModels[this._cardIndex % 52]
    const card: CardView = cardModel.view
    this._cardContainer.addChild(card)
    card.fall()

    //次のカードを生成
    this._delayedCall = gsap.delayedCall(0.5, () => {
      this.createCard()
    })
  }

  // --------------------------------------------------------------------------------------------------------------------------------------
  // --	 リサイズ
  // --------------------------------------------------------------------------------------------------------------------------------------

  resize() {
    //コンテナの位置
    this._container.x = Math.floor(this._app.renderer.width / 2)
    this._container.y = Math.floor(this._app.renderer.height / 2)
  }

  destroy(): void {
    //破棄
    this.parent.removeChild(this)
  }

  // ---------------------------------------------------------------------------------------------------------
}

export default TopView
